import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import screenComprasList from '../images/screen-compras-list.png';
import iosPurchasesDemoGif from '../images/showcase/ios-purchases-demo.gif';

const FEATURES = [
  'Importación automática desde Gmail',
  'OCR de facturas en papel',
  'Cuentas por pagar con vencimientos y abonos',
  'Libros de IVA (anexo F-07) en 1 toque',
  'Exporta Excel, CSV o JSON por período',
];

export default function ComprasModule() {
  return (
    <section className="bg-ink-50 py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block text-[11px] font-semibold uppercase tracking-[0.12em] text-brand-600 mb-4">
              Incluido en todos los planes
            </span>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-ink-950 mb-5 text-balance">
              Compras desde Gmail. En 3 segundos.
            </h2>
            <p className="text-lg text-ink-500 leading-relaxed mb-8">
              Conecta tu cuenta de Gmail y la app importa automáticamente las facturas que recibís. ¿Otra factura en papel? Sacale foto y el OCR la digitaliza al instante. Las compras a crédito alimentan tus <span className="font-semibold text-ink-800">cuentas por pagar</span> y, cuando llega fin de mes, generá los <span className="font-semibold text-ink-800">5 archivos CSV del anexo F-07</span> en un toque.
            </p>
            <ul className="space-y-3 mb-8">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check size={12} strokeWidth={3} className="text-emerald-600" />
                  </div>
                  <span className="text-[15px] text-ink-700">{f}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/documentacion"
              className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-700 font-semibold text-[15px]"
            >
              Ver el módulo de Compras
              <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
          </div>

          <div className="relative">
            <div className="absolute -inset-10 bg-gradient-to-tr from-brand-500/20 via-brand-cyan/20 to-transparent blur-3xl rounded-full" />
            <div className="relative w-[280px] mx-auto animate-float-slow">
              <div className="rounded-[44px] bg-ink-900 p-2.5 shadow-device border border-white/10">
                <div className="rounded-[36px] overflow-hidden bg-black">
                  <picture>
                    <source media="(min-width: 768px)" srcSet={iosPurchasesDemoGif} />
                    <img src={screenComprasList} alt="Módulo de Compras" className="w-full block" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
